import type { SchemaEntry } from './types';

export const DISTRIBUTION_PARTNER_RE = /^bs\.(tmf|tier_[1-4])_distributions_partner_\d+$/;
export const DISTRIBUTION_SUBTOTAL_RE = /^bs\.less_(tmf|tier_[1-4])_distributions$/;
export const PREF_RECLASS_RE = /^bs\.(preferred_equity|allocated_income)_partner_\d+$/;

export function distributionPartnerKeys(schema: SchemaEntry[]): Set<string> {
    const keys = new Set<string>();
    for (const entry of schema) {
        const key = entry.key;
        if (
            entry.tab === 'BS' &&
            entry.kind === 'input' &&
            key &&
            DISTRIBUTION_PARTNER_RE.test(key)
        ) {
            keys.add(key);
        }
    }
    return keys;
}

export function distributionSubtotalKeys(schema: SchemaEntry[]): Set<string> {
    const keys = new Set<string>();
    for (const entry of schema) {
        const key = entry.key;
        if (entry.tab === 'BS' && key && DISTRIBUTION_SUBTOTAL_RE.test(key)) {
            keys.add(key);
        }
    }
    return keys;
}

export function prefReclassKeys(schema: SchemaEntry[]): Set<string> {
    const keys = new Set<string>();
    for (const entry of schema) {
        const key = entry.key;
        if (
            entry.tab === 'BS' &&
            entry.kind === 'input' &&
            key &&
            PREF_RECLASS_RE.test(key)
        ) {
            keys.add(key);
        }
    }
    return keys;
}

function rowForKey(schema: SchemaEntry[], lineKey: string): number | null {
    for (const entry of schema) {
        if (entry.key === lineKey && entry.row != null) {
            return entry.row;
        }
    }
    return null;
}

export function totalAssetsRow(schema: SchemaEntry[]): number {
    const row = rowForKey(schema, 'bs.total_assets');
    if (row == null) {
        throw new Error('bs.total_assets not found in schema');
    }
    return row;
}

export function totalLiabilitiesAndEquityRow(schema: SchemaEntry[]): number {
    const row = rowForKey(schema, 'bs.total_liabilities_and_equity');
    if (row == null) {
        throw new Error('bs.total_liabilities_and_equity not found in schema');
    }
    return row;
}
